


















































































































































































































import {
  defineComponent,
  computed,
  ref,
  watch,
  PropType,
  nextTick
} from '@vue/composition-api';
import draggable from 'vuedraggable';
import { templateRef, watchIgnorable } from '@vueuse/core';
import { useRootInstance } from './useRootInstance';
import NumberInput from './NumberInput.vue';

type Options = {
  calculateValue?: number;
  id?: number;
  extendValue?: string;
  color?: string;
  optionValue: string | null;
  isDefault: boolean | null;
  radioValue: number | null;
};
export default defineComponent({
  components: {
    draggable,
    NumberInput
  },
  props: {
    isDraggable: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line spellcheck/spell-checker
    sigle: {
      type: Boolean,
      default: false
    },
    isCheckboxOption: {
      type: Boolean,
      default: false
    },
    isRadioOption: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array as PropType<Options[]>,
      default: () => []
    },
    isPriority: {
      type: Boolean,
      default: false
    },
    isPoint: {
      type: Boolean,
      default: false
    },
    calculateValueFlag: {
      type: Boolean,
      default: false
    },
    isUpdate: {
      type: Boolean,
      require: true
    },
    isCancel: {
      type: Boolean,
      require: true
    },
    defaultRadioCheck: {
      type: Number,
      require: true
    },
    isLabels: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const instance = useRootInstance();
    const { $inputLimit, $inputMaxLength } = instance;
    const optionsLength = ref<number | null>(null);
    // eslint-disable-next-line spellcheck/spell-checker
    const isSingle = computed(() => props.sigle);
    const canNotDeleteOption = ref<boolean>(false);
    const radioCheck = ref<number | null>(null);
    const isEvaluated = ref<boolean>(false);
    const from = ref<'options' | 'flag'>('options');
    //如果是编辑状态下的弹窗，赋分值开关初始化为calculateValueFlag
    watch(
      () => props.calculateValueFlag,
      () => {
        if (props.isUpdate) {
          isEvaluated.value = props.calculateValueFlag;
          from.value = 'flag';
        }
      },
      { immediate: true }
    );
    //如果是编辑状态下的弹窗，赋分值开关初始化为calculateValueFlag
    watch(
      () => props.defaultRadioCheck,
      () => {
        radioCheck.value = props.defaultRadioCheck! || null;
      },
      { immediate: true }
    );

    //开关状态控制
    const { ignoreUpdates } = watchIgnorable(
      () => isEvaluated.value,
      (newVal) => {
        //如果是编辑状态下的弹窗，
        if (props.isUpdate && !props.isCancel) {
          from.value = 'options';
          ignoreUpdates(() => {
            //如果是编辑状态下的弹窗并且该字段被依赖了（不能删除状态），赋分值开关初始化为calculateValueFlag
            isEvaluated.value = props.calculateValueFlag;
          });
          emit('canNotDelete', newVal);
        } else {
          from.value = 'options';
          emit('update:calculateValueFlag', newVal, from.value);
        }
      }
    );

    // 监听 labels 类型的选项变化
    watch(
      () => props.value,
      (newVal, oldVal) => {
        if (props.isLabels && props.isUpdate && oldVal) {
          newVal.forEach((newOption, index) => {
            const oldOption = oldVal[index];
            if (oldOption && 
                (newOption.optionValue !== oldOption.optionValue || 
                 newOption.color !== oldOption.color)) {
              emit('optionChange', newOption);
            }
          });
        }
      },
      { deep: true }
    );

    const radioCheckRef = templateRef<Array<HTMLElement>>('radio');
    const evaluatedInputRef = templateRef<Array<HTMLElement>>('evaluatedInput');

    watch(
      () => evaluatedInputRef.value,
      (input) => {
        const isNewCreated = input.length !== optionsLength.value;
        if (isNewCreated /* && !isSingle.value */ && input.length > 0) {
          optionsLength.value = input.length;
          nextTick(() => {
            (props.isUpdate || input.length !== 1) && evaluatedInputRef.value.at(-1)!.focus();
          });
        }
      }
    );
    watch(
      () => props.value,
      () => {
        canNotDeleteOption.value = props.value.length === 1;
      },
      { immediate: true }
    );
    const focusInput = () => {
      if (evaluatedInputRef.value) {
        if (evaluatedInputRef.value.length > 0) {
          nextTick(() => {
            evaluatedInputRef.value.at(-1)!.focus();
          });
        }
      }
    };

    //当选项不是优先级以及点数的特殊选项时返回true
    const isNotSpecialOption = computed(
      () => !props.isPoint && !props.isPriority
    );
    const blurToNull = () => {
      emit('blur-null');
    };
    const handleRadioClick = (id?: number, index?: number) => {
      //把当前的label传给父组件
      radioCheck.value = radioCheck.value === id! ? null : id!;
      // // 点击完成失去焦点，解决有蓝色阴影
      (radioCheckRef.value![index!] as any).$el.blur();
      emit('update:radioCheck', id);
    };
    const removeOption = (index: number) => {
      emit('removeOption', index);
    };
    const checkCreated = (id: number | null) => {
      emit('checkCreated', id);
    };
    const addOption = (operate = 'enter') => {
      emit('addOption', operate);
    };
    const onStart = () => {
      document.documentElement.classList.add('draggable-cursor-grabbing');
    };
    const onEnd = () => {
      document.documentElement.classList.remove('draggable-cursor-grabbing');
    };
    const optionList = computed({
      get: () => props.value,
      set: (newVal) => {
        emit('input', newVal);
      }
    });
    const clear = () => {
      isEvaluated.value = false;
    };
    const fieldOptionType = computed(() => {
      return $inputLimit.fieldOption > $inputMaxLength ? 'textarea' : 'text';
    });
    return {
      radioCheck,
      optionList,
      isCheckbox: computed(() => props.isCheckboxOption),
      isRadio: computed(() => props.isRadioOption),
      onStart,
      onEnd,
      handleRadioClick,
      removeOption,
      addOption,
      inputLimit: $inputLimit,
      isSingle,
      checkCreated,
      isEvaluated,
      clear,
      focusInput,
      // hasValue,
      isNotSpecialOption,
      canNotDeleteOption,
      blurToNull,
      disabledSort: computed(() => props.isPoint),
      fieldOptionType
    };
  }
});
